module.exports = __webpack_public_path__ + "fonts/AudiType-ExtendedNormal_4.03.72f614b1.woff2";